import React from 'react';
import './index.css';
import App from './App';
import { createRoot } from 'react-dom/client';
// import reportWebVitals from './reportWebVitals';
// import ReactDOM from 'react-dom';

const container = document.getElementById('root');
const root = createRoot(container);
console.log(process.env.PROXY_API);
root.render(
	<React.StrictMode>
		<App />
	</React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
